/* eslint-disable import/prefer-default-export */

const axios = require('axios').default;

import {
} from '../constants/partnershipStatusConstants';
